(function(app) {

    app.provider("marketingTrackerAgentApi",
    [
        function() {
            this.$get = [
                "marketingTrackerApiGateway", function(marketingTrackerApiGateway) {
                    var service = {};

                    service.get = function () {
                        return marketingTrackerApiGateway.get("/Agents/Current");
                    };

                    service.getForFigAuth = function (figAuthUserId) {
                        return marketingTrackerApiGateway.get("/Agents/FigAuth/" + figAuthUserId);
                    };

                    service.getContactPoliciesByEmail = function (agentEmail) {
                        return marketingTrackerApiGateway.get("/Agents/ClientPoliciesByEmail/" + agentEmail);
                    };
                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line